<template>
  <div class="letters">
    <p class="error" v-if="userAddresses.length == 0">
      {{ $t("letters.userAddressMissing") }}
    </p>
    <div class="row">
      <div class="col-xs-12 col-sm-4">
        <div>
          <div class="form-group row">
            <label class="col-sm-4 form-label">{{
              $t("letters.select")
            }}</label>
            <select class="form-control col" v-model="selectedLetter">
              <option :value="null">{{ $t("letters.createNew") }}</option>

              <option v-for="(l, key) in letters" :key="key" :value="l">
                {{ l.name || "nimetön" }}
              </option>
            </select>
          </div>
          <div class="form-group row">
            <label class="col-sm-4 form-label">{{ $t("letters.name") }}</label>
            <input
              class="form-control col"
              v-model.trim="template.name"
              :placeholder="$t('letters.name')"
            />
          </div>
        </div>
      </div>
    </div>
    <p class="text-left">{{ $t("letters.attachmentInfo") }}</p>
    <p class="text-left">{{ $t("letters.attachmentInfo2") }}</p>
    <div class="row" id="editorrow" style="position: relative">
      <div class="col-sm-10">
        <div>
          <ul class="language-tabs nav nav-tabs">
            <li v-for="(l, key) in languages" :key="key" class="nav-item">
              <div
                :class="{ active: language === l.value && !viewAttachment }"
                class="nav-link"
                @click="changeTab(l.value)"
              >
                {{ $t("languages." + l.name) }}
              </div>
            </li>
            <li class="nav-item" :class="{ disabled: !template.blobFI }">
              <div
                :class="{ active: viewAttachment }"
                class="nav-link"
                @click="changeTab('attachment')"
              >
                {{ $t("letters.attachment") }}
              </div>
            </li>
            <div class="col mt-2">
              <label
                v-show="!template.blobFI"
                class="float-left"
                style="height: 27px"
              >
                <span class="upload-button">{{
                  $t("letters.selectFile")
                }}</span>
                <input
                  :ref="'files'"
                  type="file"
                  @input="selectFile"
                  accept="application/pdf"
                />
              </label>
              <span
                class="upload-button float-left ml-2"
                v-if="template.blobFI"
                @click.self="removeFile"
                >{{ $t("letters.removeAttachment") }}</span
              >
              <span class="float-left" v-if="file">: {{ file.name }}</span>
            </div>
          </ul>

          <input
            style="border-radius: 0"
            class="form-control col"
            v-model="currentSubject"
            :placeholder="$t('letters.subject')"
          />
          <quill-editor
            v-if="!viewAttachment"
            v-model.trim="currentText"
            ref="quillEditor"
            :options="editorOption"
          ></quill-editor>
          <iframe class="upload-preview" v-else :src="template.blobFI"></iframe>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-sm-10">
        <button
          class="btn btn-success float-left"
          v-on:click.prevent="remove"
          :disabled="disabled"
        >
          {{ $t("letters.remove") }}
        </button>
        <button
          class="btn btn-success float-left"
          @click="sendExample"
          :disabled="disabled || !validateEmail"
        >
          {{ $t("letters.sendTest") }}
        </button>
        <input
          v-model="exampleEmail"
          class="example-email-field form-control"
          :placeholder="$t('letters.exampleEmail')"
          :class="{
            'is-invalid': validateEmail === false,
            'is-valid': validateEmail === true,
            '': validateEmail === null,
          }"
        />
        <button
          v-if="!selectedLetter"
          class="btn btn-success float-right"
          v-on:click="add(null)"
        >
          {{ $t("letters.create") }}
        </button>
        <button v-else class="btn btn-success float-right" v-on:click="save">
          {{ $t("letters.update") }}
        </button>
        <button
          class="btn btn-success mr-2 ml-2 float-right"
          v-on:click.prevent="getPDF"
          :disabled="disabled || template.blobFI"
        >
          {{ $t("letters.downloadPDF") }}
        </button>

        <button
          class="btn btn-success float-right"
          @click="openPreviewWindow"
          :disabled="disabled || template.blobFI"
        >
          {{ $t("letters.preview") }}
        </button>
      </div>
    </div>
    <letter-preview
      v-on:close="openPreview = false"
      :open="openPreview"
      :url="previewDataUrl"
    ></letter-preview>
    <modal :loading="loading"></modal>
  </div>
</template>

<script>
import Vue from "vue";
import Quill from "quill";
import { defaultLetter } from "@/assets/defaultletter";
import LetterPreview from "../components/letters/LetterPreview";
import Modal from "../components/common/Modal";
import { validateEmail } from "@/utils";

/* import { ImageImport } from '@/modules/ImageImport.js'
import { ImageResize } from '@/modules/ImageResize.js'
Quill.register('modules/imageImport', ImageImport)
Quill.register('modules/imageResize', ImageResize) */
import { mapActions, mapGetters } from "vuex";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    quillEditor,
    LetterPreview,
    Modal,
  },
  /** create default letter if no previous letters */
  mounted: async function () {
    const officialAddress = this.userAddresses.find(
      (a) => a.AddressType == "Official"
    );
    try {
      let res = await this.$store.dispatch("listLetters");
      if (res.length == 0) {
        let baseTemplate = Object.assign({}, defaultLetter);
        let OVT = "0037" + this.userData.Ytunnus.replace("-", "");
        this.languages.forEach((l) => {
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__OVT_ID__/g, OVT);
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__BUSINESS_ID__/g, this.userData.Ytunnus);
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__BUSINESS_NAME__/g, this.userData.Name);
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__STREET__/g, officialAddress.Street1);
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__POSTCODE__/g, officialAddress.PostalCode);
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__POSTOFFICE__/g, officialAddress.PostalOffice);
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__CONTACT_PERSON__/g, this.userData.ContactPerson);
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__PHONE__/g, this.userData.Phonenumber);
          baseTemplate["text" + l.value] = baseTemplate[
            "text" + l.value
          ].replace(/__EMAIL__/g, this.userData.Email);
          let etag = this.userContracts.find((c) => c.ContractType === "eTag");
          if (etag) {
            baseTemplate["text" + l.value] = baseTemplate[
              "text" + l.value
            ].replace(/@__ETAG__@/g, etag.Parameters);
          }
        });
        this.add(baseTemplate);
      } else {
        this.letters = res.map((l) => {
          if (l.blobFI === "false") {
            l.blobFI = null;
          } else {
            l.blobFI = true;
          }
          return l;
        });
        this.selectedLetter = this.letters[0];
      }
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    ...mapGetters(["userData", "userAddresses", "userContracts"]),
    disabled: function () {
      return this.template.letterId === null;
    },
    validateEmail: function () {
      return validateEmail(this.exampleEmail);
    },
    currentText: {
      get: function () {
        return this.template["text" + this.language];
      },
      set: function (value) {
        this.template["text" + this.language] = value;
      },
    },
    currentSubject: {
      get: function () {
        return this.template["subject" + this.language];
      },
      set: function (value) {
        this.template["subject" + this.language] = value;
      },
    },

    currentName: {
      get: function () {
        if (this.selectedLetter) {
          return this.selectedLetter.name;
        } else {
          return this.template.name;
        }
      },
      set: function (value) {
        if (this.selectedLetter) {
          this.selectedLetter.name = value;
        } else {
          this.template.name = value;
        }
      },
    },
    editor() {
      return this.$refs.quillEditor.quill;
    },
  },
  data() {
    return {
      pdfObjectUrl: null,
      openPreview: false,
      previewDataUrl: "",
      file: null,
      loading: false,
      exampleEmail: "",
      template: {
        letterId: null,
        name: "",
        subjectFI: "",
        textFI: "",
        subjectSV: "",
        textSV: "",
        subjectDE: "",
        textDE: "",
        subjectEN: "",
        textEN: "",
        blobFI: null,
      },
      language: "FI",
      languages: [
        {
          name: "finland",
          value: "FI",
        },
        {
          name: "sweden",
          value: "SV",
        },
        {
          name: "england",
          value: "EN",
        },
      ],
      viewAttachment: false,
      selectedLetter: null,
      letters: [],
      error: {
        name: false,
      },
      editorOption: {
        placeholder: "",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            /* [{ list: "ordered" }, { list: "bullet" }], */
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            /*  [{ font: [] }], */
            /*  [{ align: [] }], */
          ],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
        },
      },
    };
  },
  methods: {
    changeTab: function (value) {
      if (value === "attachment") {
        if (this.template.blobFI) {
          this.viewAttachment = true;
        }
      } else {
        this.language = value;
        this.viewAttachment = false;
      }
    },
    removeFile: function () {
      this.file = null;
      this.$refs.files.value = "";
      this.template.blobFI = null;
    },
    selectFile: function (e) {
      var reader = new FileReader();
      reader.onload = () => {
        this.template.blobFI = reader.result;
      };
      if (e.target.files) {
        this.file = e.target.files[0];
        reader.readAsDataURL(e.target.files[0]);
      } else {
        this.file = null;
        this.$refs.files.value = "";
      }
    },
    openPreviewWindow: async function () {
      try {
        const letterId = this.selectedLetter.letterId;
        const lang = this.language;
        const name = this.selectedLetter.name;
        let url = "";
        if (
          this.pdfObjectUrl &&
          this.pdfObjectUrl.letterId == letterId &&
          this.pdfObjectUrl.lang == lang
        ) {
          url = this.pdfObjectUrl.url;
        } else {
          let request = {
            letterid: letterId,
            lang: lang,
          };
          let res = await this.$store.dispatch("downloadLetterPDF", request);
          let blob = new Blob([res.data], {
            type: res.headers.get("content-type"),
          });
          url = window.URL.createObjectURL(blob);
          this.pdfObjectUrl = {
            letterId,
            name,
            lang,
            url,
          };
        }
        this.previewDataUrl = url;
        this.openPreview = true;
      } catch (error) {
        console.log(error);
      }
    },

    getPDF: async function () {
      try {
        const letterId = this.selectedLetter.letterId;
        const lang = this.language;
        const name = this.selectedLetter.name;
        let url = "";
        if (
          this.pdfObjectUrl &&
          this.pdfObjectUrl.letterId == letterId &&
          this.pdfObjectUrl.lang == lang
        ) {
          url = this.pdfObjectUrl.url;
        } else {
          let request = {
            letterid: letterId,
            lang: lang,
          };
          let res = await this.$store.dispatch("downloadLetterPDF", request);
          let blob = new Blob([res.data], {
            type: res.headers.get("content-type"),
          });
          url = window.URL.createObjectURL(blob);
          this.pdfObjectUrl = {
            letterId,
            name,
            lang,
            url,
          };
        }
        let link = document.createElement("a");
        document.body.appendChild(link);

        link.href = url;
        link.download = this.selectedLetter.name + ".pdf";
        link.click();
        setTimeout(function () {
          document.body.removeChild(link);
        }, 500);
      } catch (error) {
        console.log(error);
      }
    },
    save: async function () {
      try {
        let res = await this.$store.dispatch("updateLetter", this.template);
        this.$notify({
          text: this.$t("letters.updated"),
          type: "success",
          duration: 5000,
        });
        if (this.template.name) {
          let idx = this.letters.findIndex(
            (l) => l.letterId === this.template.letterId
          );

          this.$set(this.letters, idx, Object.assign({}, this.template));
          this.selectedLetter = this.letters[idx];
        }
        if (
          this.pdfObjectUrl &&
          this.pdfObjectUrl.letterId == this.template.letterId &&
          this.pdfObjectUrl.lang == this.language
        ) {
          this.pdfObjectUrl = null;
        }
      } catch (error) {
        console.log(error);
        if (error.body.error.includes("Text too long")) {
          this.$notify({
            text:
              this.$t("letters.errorTooLong") +
              ": " +
              error.body.error.substr(14, 16),
            type: "error",
            duration: 5000,
          });
        } else {
          this.$notify({
            text: this.$t("letters.errorUpdating"),
            type: "error",
            duration: 5000,
          });
        }
      }
    },
    add: async function (letter) {
      try {
        let res = await this.$store.dispatch(
          "addLetter",
          letter || this.template
        );
        this.selectedLetter = res;
        this.letters.push(res);
        this.$notify({
          text: this.$t("letters.addSuccessful"),
          type: "success",
          duration: 5000,
        });
      } catch (error) {
        console.log(error);
        this.$notify({
          text: this.$t("letters.errorAdding"),
          type: "error",
          duration: 5000,
        });
      }
    },
    remove: function () {
      this.$openModal({
        type: "confirm",
        text: this.$t("letters.confirmRemove", {
          name: this.selectedLetter.name,
        }),
        title: this.$t("modal.remove"),
        callback: async () => {
          this.loading = true;
          try {
            let res = await this.$store.dispatch("removeLetter", {
              letterid: this.template.letterId,
            });
            this.letters = this.letters.filter(
              (l) => l.letterId !== this.template.letterId
            );
            this.selectedLetter = this.letters[0] || null;
            this.$notify({
              text: this.$t("letters.removeSuccessful"),
              type: "success",
              duration: 5000,
            });
          } catch (error) {
            this.$notify({
              text: this.$t("letters.errorRemoving"),
              type: "error",
              duration: 5000,
            });
            console.log(error);
          } finally {
            this.$closeModal();
            this.loading = false;
          }
        },
      });
    },
    sendExample: async function () {
      if (this.validateEmail) {
        this.$openModal({
          type: "confirm",
          text: this.$t("letters.confirmTest", {
            email: this.exampleEmail,
          }),
          title: this.$t("modal.confirmSending"),
          callback: async () => {
            this.loading = true;
            try {
              let res = await this.$store.dispatch("sendExample", {
                letterId: this.template.letterId,
                language: this.language,
                email: this.exampleEmail,
              });
              if (res.success) {
                this.$notify({
                  text: this.$t("letters.exampleSentSuccessful"),
                  type: "success",
                  duration: 5000,
                });
              }
            } catch (error) {
              console.log(error);
              this.$notify({
                text: this.$t("letters.errorSendingExample"),
                type: "error",
                duration: 5000,
              });
            } finally {
              this.$closeModal();
              this.loading = false;
            }
          },
        });
      }
    },
  },
  watch: {
    "template.Name": function (value) {
      if (value) {
        this.error.name = false;
      }
    },
    selectedLetter: function (letter) {
      this.viewAttachment = false;
      if (letter) {
        this.template.name = letter.name;
        this.template.textFI = letter.textFI;
        this.template.textSV = letter.textSV;
        this.template.textEN = letter.textEN;
        this.template.letterId = letter.letterId;
        this.template.subjectFI = letter.subjectFI;
        this.template.subjectEN = letter.subjectEN;
        this.template.subjectSV = letter.subjectSV;

        if (letter.blobFI) {
          this.$store
            .dispatch("getLetterAttachment", letter.letterId)
            .then((res) => {
              this.template.blobFI = res.attachment;
            });
        } else {
          this.template.blobFI = null;
        }

        this.file = null;
      } else {
        this.template.name = "";
        this.template.textFI = "";
        this.template.textSV = "";
        this.template.textEN = "";
        this.template.letterId = null;
        this.template.subjectFI = "";
        this.template.subjectEN = "";
        this.template.subjectSV = "";
        this.template.blobFI = null;
        this.file = null;
      }
    },

    language: function (value) {
      this.$nextTick(() => {
        this.editor.focus();
      });
    },
  },
};
</script>

<style scoped>
.upload-preview {
  min-height: 800px;
  width: 100%;
}
.error {
  color: red;
  width: 100%;
}
.nav-tabs .nav-item .nav-link {
  background-color: #fff;
  cursor: pointer;
  color: #212529;
}
.language-tabs .active {
  border-bottom: solid 3px rgb(255, 115, 0);
}
.disabled .nav-link {
  opacity: 0.6;
  border-bottom: none;
}
.btn-success:nth-child(2) {
  margin-left: 8px;
}

.btn-success:nth-child(4) {
  margin-left: 8px;
}
input[type="file"] {
  display: none;
}
.upload-button {
  color: #fff;
  cursor: pointer;
  text-decoration: underline;
}
.upload-button:hover {
  text-decoration: underline;
}
.example-email-field {
  width: 12em;
  float: left;
  margin-left: 10px;
}

@media screen and (max-width: 768px) {
  .btn-success:nth-child(5) {
    display: none;
  }
}
@media screen and (max-width: 426px) {
  .btn-success:nth-child(2) {
    margin-left: 0px;
  }

  .btn-success:nth-child(4) {
    margin-right: 0px;
  }
  .btn-success {
    width: 10em;
    margin: auto;
    float: none !important;
    margin-bottom: 10px;
  }
  .example-email-field {
    margin: auto;
    margin-bottom: 5px;
    float: none !important;
  }
}
</style>
<style>
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  line-height: 1.2;
  font-weight: 800 !important;
}
.ql-snow .ql-editor h1 {
  font-size: 26px !important;
  font-weight: 800 !important;
}
.ql-snow .ql-editor h2 {
  font-weight: 800 !important;
}
.ql-snow .ql-editor h3 {
  font-weight: 800 !important;
}
.letters {
  max-width: 1400px;
  margin: auto;
}
.ql-container {
  padding: 1em;
  background-color: rgb(202, 201, 201);
}
.ql-container .ql-editor {
  border: 1px solid rgba(0, 0, 0, 0.5);
  min-height: 800px;
  max-width: 645px;
  margin: auto;
  padding: 2.5em 2.5em 5em 2.5em;
  background-color: #fff;
  color: #212529;
  font-family: "Times New Roman" !important;
}
.ql-toolbar {
  background-color: #fff;
}

.ql-formats {
  float: left;
}

#editorrow {
  max-height: 100%;
}
</style>
